import React from 'react';
import { useTranslation } from 'react-i18next';
import BarWithLineChart from '../../../components/charts/BarWithLineChart';
import { IKpisChartData } from '../../../types/kpis';

interface IMaintenabilityChart {
  mttrData: IKpisChartData;
  failureData: number[];
  kpiLabels: string[];
  width?: string | number;
  height?: string | number;
  showTitle?: boolean;
}

const MaintenabilityChart: React.FC<IMaintenabilityChart> = ({
  mttrData,
  failureData,
  kpiLabels,
  width,
  height,
  showTitle,
}) => {
  const { t } = useTranslation();
  return (
    <BarWithLineChart
      title={showTitle ? t('screens:availability.maintainability') : undefined}
      showLegend
      series={[
        {
          name: 'MTTR (horas)',
          type: 'column',
          data: mttrData.data,
        },
        {
          name: t('screens:availability.numberOfFailures'),
          type: 'line',
          data: failureData,
        },
      ]}
      categories={kpiLabels}
      width={width}
      height={height}
    />
  );
};

export default MaintenabilityChart;
